import { PATHS } from "@/lib/router";
import GElementPage from "./pages/GElementPage";

export const gElementRoutes = [
  {
    path: PATHS.G_Element,
    element: <GElementPage />,
  },
];
